'use strict';

function ContentCenter() {
  var _this7 = this;

  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [_ContentCenterController, _ResponsiveLayout, _ErrorController];
  this.declaredClass = null;
  this.presenter = null;

  this._analytics = new Analytics();
  this._history = new History();

  this._bannerIndexAction = 'account.index_content_center'; // (TODO)
  this._bannerDismissAction = 'account.dismiss_content_center'; // (TODO)
  this._disabledArrowClass = 'dashboard-home__content-centre-arrow--disabled';
  this._bannerNavCurrentClass = 'dashboard-home__content-centre-nav-item--current';
  this._currentBannerIndex = 0;
  this._bannerWidth = 0;
  this._bannerSeparation = 20;
  this._bannerContentfulKey = null;
  this._banners = null;
  this._magicXLargeWindowWidth = 2150;
  this._magicXLargeBannerWidth = 1150;

  this.elements = {};
  this._elementClasses = {
    spinner: 'js--spinner',
    bannerList: 'js--banner-list',
    prevButton: 'js--prev-btn',
    nextButton: 'js--next-btn',
    bannerNav: 'js--banner-nav'
  };

  this.init = function () {
    var _this = this;

    this._super();

    // add banner list, navigation elements to DOM
    this.node.innerHTML = this.node.innerHTML + '\n    <div class="dashboard-home__content-centre-banners-container">\n      <ul class="dashboard-home__content-centre-banners ' + this._elementClasses.bannerList + '"></ul>\n    </div>\n    <button class="dashboard-home__content-centre-arrow dashboard-home__content-centre-arrow--next ' + this._disabledArrowClass + ' ' + this._elementClasses.nextButton + '" data-analytics-id>\n      <svg class="svg-icon" viewBox="0 0 32 32">\n        <use xlink:href="#icon-arrow"></use>\n      </svg>\n    </button>\n    <button class="dashboard-home__content-centre-arrow dashboard-home__content-centre-arrow--prev ' + this._disabledArrowClass + ' ' + this._elementClasses.prevButton + '" data-analytics-id>\n      <svg class="svg-icon" viewBox="0 0 32 32">\n        <use xlink:href="#icon-arrow"></use>\n      </svg>\n    </button>\n    <ul class="dashboard-home__content-centre-nav ' + this._elementClasses.bannerNav + '"></ul>';

    // cache element references
    for (var className in this._elementClasses) {
      this.elements[className] = this.node.getElementsByClassName(this._elementClasses[className])[0];
    }

    // attach event listeners to prev / next buttons
    this.elements.prevButton.addEventListener('click', function (e) {
      if (!_this.elements.prevButton.classList.contains(_this._disabledArrowClass)) {
        _this._showPreviousBanner();
      }
    });
    this.elements.nextButton.addEventListener('click', function (e) {
      if (!_this.elements.nextButton.classList.contains(_this._disabledArrowClass)) {
        _this._showNextBanner();
      }
    });

    // Get banner content
    this.retrieveBanners(this._populateContentCenter.bind(this));

    // adjust banner sizes based on available width
    this.registerResponsiveFunction(this._setDimensions.bind(this), null, null);
  };

  this._populateContentCenter = function (data, response) {
    var _this2 = this;

    // remove spinner
    this.elements.spinner.addClass('fade-out');
    setTimeout(function () {
      _this2.node.removeChild(_this2.elements.spinner);
    }, 500);

    if (response === 200) {
      // exclude dismissed banners
      this._banners = data.banners.filter(function (banner) {
        return !banner.isDismissed();
      });

      // build banners
      this._banners.forEach(function (banner) {
        _this2._addBanner(banner);
      });

      this.node.classList.add('loaded');

      // fake first slide animation
      this._slideInBanner();

      // go to first / requested banner (deeplink TODO)
      this._showBanner(0);

      // Error case: hide Content Center
    } else {
      this.node.style.height = '0px';
      this.node.style.paddingBottom = '0px';
      this.node.classList.remove('dashboard-home__content-centre--visible');
    }
  };

  this._addBanner = function (banner) {
    var _this3 = this;

    // Get banner content
    var bannerContent = banner.getContent();
    var referralContent = banner.getReferralContent();
    var bannerLink = banner.getBannerLink();
    var contentfulId = banner.getId();

    this._bannerContentfulKey = this._sanitizeSlideKey(banner._getContentfulKey());
    this._bannerContentfulUpdatedAt = this._sanitizeSlideKey(banner._getContentfulUpdatedAt());

    if (bannerContent) {
      if (referralContent) {
        var referralCode = this.presenter.getModelProperty('account.referral_code');
        bannerLink = 'mailto:?subject=' + referralContent.emailSubject + '&body=' + encodeURIComponent(referralContent.emailDescription) + encodeURIComponent(referralContent.baseUrl) + encodeURIComponent('?referral_code=') + referralCode + '%0D%0D';
      }
      // build banner HTML
      var bannerNode = document.createElement('li');
      bannerNode.className = 'dashboard-home__content-centre-banner ' + (banner.isDismissible() ? 'dashboard-home__content-centre-banner--dismissable' : '');
      bannerNode.id = contentfulId;
      bannerNode.innerHTML = '\n      <' + (bannerLink ? 'a data-history="true" data-analytics-id ' + (isExternalLink(bannerLink) && 'target=_blank') : 'div') + ' class="dashboard-home__content-centre-banner-content">\n        <div class="dashboard-home__content-centre-banner-image-container js--image-container"></div>\n        <div class="dashboard-home__content-centre-banner-text">\n          <h3 class="dashboard-home__content-centre-banner-subtitle">' + bannerContent.title + '</h3>\n          <p class="dashboard-home__content-centre-banner-description">' + bannerContent.content + '</p>\n        </div>\n      </' + (bannerLink ? 'a' : 'div') + '>\n      <button class="dashboard-home__content-centre-banner-dismiss js--dismiss-button" data-analytics-id></button>';

      // add link to banner
      if (bannerLink) {
        var _bannerContent = bannerNode.getElementsByClassName('dashboard-home__content-centre-banner-content')[0];
        _bannerContent.setAttribute('href', bannerLink);
        _bannerContent.dataset.analyticsId = 'MogoMember-CC Navigation-' + this._bannerContentfulKey + '=' + this._bannerContentfulUpdatedAt + '=CTA-Navigation-Component';
      }

      // populate image
      this._addBannerMedia(bannerNode.getElementsByClassName('js--image-container')[0], bannerContent);

      // add event handler to dismiss button
      bannerNode.getElementsByClassName('js--dismiss-button')[0].dataset.analyticsId = 'MogoMember-CC Navigation-' + this._bannerContentfulKey + '=' + this._bannerContentfulUpdatedAt + '=Close-Navigation-Component';

      $('#Portal').mogo().scanNodeForClickAnalytics(bannerNode);

      // note: respects spa by preventing page reload when link is clicked.
      this._history.initializeHistoryOnDocument(bannerNode);

      bannerNode.getElementsByClassName('js--dismiss-button')[0].addEventListener('click', function (e) {
        _this3._dismissBanner(e.target.parentNode, contentfulId);
      });

      // append to banner list DOM
      this.elements.bannerList.appendChild(bannerNode);
      this._setDimensions();

      // append item to banner nav DOM
      var navElementNode = document.createElement('li');
      navElementNode.className = 'dashboard-home__content-centre-nav-item';
      this.elements.bannerNav.appendChild(navElementNode);

      // add event handler to nav item
      navElementNode.addEventListener('click', function (e) {
        _this3._currentBannerIndex = Array.from(e.target.parentNode.childNodes).indexOf(e.target);
        _this3._showBanner(_this3._currentBannerIndex);
      });
    }
  };

  this._addBannerMedia = function (container, bannerContent) {
    var useStaticMediaOnWeb = bannerContent.useStaticMediaOnWeb,
        mediaType = bannerContent.mediaType,
        mediaUrl = bannerContent.mediaUrl,
        alternativeMediaUrl = bannerContent.alternativeMediaUrl;


    if (useStaticMediaOnWeb || mediaType === 'undefined') {
      this._loadImage(container, alternativeMediaUrl);
    } else if (mediaType === 'application/json') {
      this._loadAnimation(container, mediaUrl);
    } else {
      this._loadImage(container, mediaUrl);
    }
  };

  this._loadAnimation = function (container, mediaUrl) {
    container.innerHTML = this._getAnimationHTML();

    var animationElement = container.querySelector('.js--animation');
    var config = {
      loop: true,
      autoplay: true,
      url: mediaUrl
    };
    this.animation = bodymovin.loadAnimation({
      container: animationElement,
      loop: config.loop,
      autoplay: config.autoplay,
      path: config.url
    });
  };

  this._getAnimationHTML = function () {
    return '<div class="dashboard-home__content-centre-banner-image animation js--animation" />';
  };

  this._loadImage = function (container, mediaUrl) {
    container.innerHTML = this._getImageHTML(mediaUrl);
  };

  this._getImageHTML = function (url) {
    return '<img class="dashboard-home__content-centre-banner-image" src="' + url + '" />';
  };

  this._dismissBanner = function (target, bannerId) {
    var _this4 = this;

    // record which banner is being dismissed
    this.dismissBanner(bannerId, function (data, response) {
      if (response === 200) {
        // remove banner
        target.classList.add('dismiss-animation');
        _this4._removeBanner(_this4._currentBannerIndex);

        // show prev banner if dismissed banner is not first, else show next banner
        if (_this4._currentBannerIndex !== 0) {
          _this4._currentBannerIndex--;
        }
        setTimeout(function () {
          _this4._showBanner(_this4._currentBannerIndex, _this4._currentBannerIndex === 0);
        }, 400);
      } else {
        console.error('banner could not be dismissed');
      }
    });
  };

  this._removeBanner = function (bannerIndex) {
    var _this5 = this;

    setTimeout(function () {
      // remove from DOM
      _this5.elements.bannerList.removeChild(_this5.elements.bannerList.childNodes[bannerIndex]);

      // remove item from banner nav DOM
      _this5.elements.bannerNav.removeChild(_this5.elements.bannerNav.childNodes[bannerIndex]);

      // remove item from banner list
      _this5._banners.splice(bannerIndex, 1);
    }, 400);
  };

  this._showBanner = function (bannerIndex, slideAfterDismiss) {
    var _this6 = this;

    this._pushSlideNavAnalytics(this._currentBannerIndex);

    this._currentBannerIndex = bannerIndex;

    // animate slides opacity
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.elements.bannerList.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var slide = _step.value;

        if (slide.classList.contains('fade-in')) slide.classList.remove('fade-in');
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this.elements.bannerList.childNodes[bannerIndex].classList.add('fade-in');

    // animate slides positioning
    this.elements.bannerList.style.left = -(this._bannerWidth + this._bannerSeparation) * bannerIndex + 'px';

    // update banner nav
    var currentNavItem = this.elements.bannerNav.getElementsByClassName(this._bannerNavCurrentClass);
    if (currentNavItem.length) {
      currentNavItem[0].classList.remove(this._bannerNavCurrentClass);
    }
    this.elements.bannerNav.childNodes[bannerIndex].classList.add(this._bannerNavCurrentClass);

    // if banner is first or last, disable corresponding nav arrow
    if (bannerIndex === 0) {
      this.elements.prevButton.classList.add(this._disabledArrowClass);
    } else {
      this.elements.prevButton.classList.remove(this._disabledArrowClass);
    }
    if (bannerIndex === this.elements.bannerList.childNodes.length - 1) {
      this.elements.nextButton.classList.add(this._disabledArrowClass);
    } else {
      this.elements.nextButton.classList.remove(this._disabledArrowClass);
    }

    if (slideAfterDismiss) this._slideInBanner();

    // wait for slide transition
    setTimeout(function () {
      _this6._pushAnalytics(_this6._currentBannerIndex);
    }, 1000);
  };

  this._slideInBanner = function () {
    _this7.node.classList.add('slide-in');

    // wait for slide transition
    setTimeout(function () {
      _this7.node.classList.remove('slide-in');
    }, 1000);
  };

  this._showPreviousBanner = function () {
    if (this._currentBannerIndex > 0) {
      this._showBanner(this._currentBannerIndex - 1);
    }
  };

  this._showNextBanner = function () {
    if (this._currentBannerIndex < this.elements.bannerList.childNodes.length) {
      this._showBanner(this._currentBannerIndex + 1);
    }
  };

  this._setDimensions = function () {
    var totalMargin = {
      small: 40,
      medium: 200,
      large: 220
    };

    if (window.innerWidth <= window.mogo.registry.mogoUI.config.mediaQueries.small) {
      this._bannerWidth = this.node.parentNode.offsetWidth - totalMargin.small;
    } else if (window.innerWidth <= window.mogo.registry.mogoUI.config.mediaQueries.medium) {
      this._bannerWidth = this.node.parentNode.offsetWidth - totalMargin.medium;
    } else if (window.innerWidth <= this._magicXLargeWindowWidth) {
      this._bannerWidth = this.node.parentNode.offsetWidth - totalMargin.large;
    } else {
      this._bannerWidth = this._magicXLargeBannerWidth;
    }

    var bannerCount = this.elements.bannerList.childNodes.length;
    this.elements.bannerList.style.width = (this._bannerWidth + this._bannerSeparation) * bannerCount + 'px';
    for (var bannerIndex = 0; bannerIndex <= bannerCount - 1; bannerIndex++) {
      this.elements.bannerList.childNodes[bannerIndex].style.width = this._bannerWidth + 'px';
    }

    // fix current banner position
    this.elements.bannerList.style.left = -(this._bannerWidth + this._bannerSeparation) * this._currentBannerIndex + 'px';
  };

  this._pushSlideNavAnalytics = function (bannerIndex) {
    // analytics for arrows
    if (bannerIndex > 0) {
      this._bannerContentfulKeyPrev = this._sanitizeSlideKey(this._banners[bannerIndex - 1]._getContentfulKey());
      this._bannerContentfulUpdatedAtPrev = this._sanitizeSlideKey(this._banners[bannerIndex - 1]._getContentfulUpdatedAt());
      this.elements.prevButton.dataset.analyticsId = 'MogoMember-CC Navigation-' + this._bannerContentfulKeyPrev + '=' + this._bannerContentfulUpdatedAtPrev + '=Left-Navigation-Component';
    }
    if (bannerIndex < this._banners.length - 1) {
      this._bannerContentfulKeyNext = this._sanitizeSlideKey(this._banners[bannerIndex + 1]._getContentfulKey());
      this._bannerContentfulUpdatedAtNext = this._sanitizeSlideKey(this._banners[bannerIndex + 1]._getContentfulUpdatedAt());
      this.elements.nextButton.dataset.analyticsId = 'MogoMember-CC Navigation-' + this._bannerContentfulKeyNext + '=' + this._bannerContentfulUpdatedAtNext + '=Right-Navigation-Component';
    }
  };

  this._sanitizeSlideKey = function (key) {
    return key.replace(/-+/g, '=');
  };

  this._pushAnalytics = function (bannerIndex) {
    // analytics for current slide
    this._bannerContentfulKey = this._sanitizeSlideKey(this._banners[bannerIndex]._getContentfulKey());
    this._bannerContentfulUpdatedAt = this._sanitizeSlideKey(this._banners[bannerIndex]._getContentfulUpdatedAt());
    var message = this._bannerContentfulKey ? this._bannerContentfulKey + '=' + this._bannerContentfulUpdatedAt : 'Not Loaded';
    this._analytics.forcePushEvent('cc-status', { message: ['' + message] });
  };

  this.initAllReady = function () {
    this._super();
  };

  this.destroy = function () {
    this._super();
    this.deregisterResponsiveFunctions();
  };
}